import { render, staticRenderFns } from "./SuperAdminClientsDetails.vue?vue&type=template&id=7bb56cda&scoped=true&"
import script from "./SuperAdminClientsDetails.vue?vue&type=script&lang=js&"
export * from "./SuperAdminClientsDetails.vue?vue&type=script&lang=js&"
import style0 from "./SuperAdminClientsDetails.vue?vue&type=style&index=0&id=7bb56cda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb56cda",
  null
  
)

export default component.exports